import { render, staticRenderFns } from "./InformationEdit.vue?vue&type=template&id=baf52bfc&scoped=true"
import script from "./InformationEdit.vue?vue&type=script&lang=js"
export * from "./InformationEdit.vue?vue&type=script&lang=js"
import style0 from "./InformationEdit.vue?vue&type=style&index=0&id=baf52bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf52bfc",
  null
  
)

export default component.exports